import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { trackPorCodigo } from 'src/app/services/odoo/odoo-maestros-formato';
import { OdooEstadoUi, OdooFilaComercio, OdooListaFiltro, OdooPaginaLista } from 'src/app/services/odoo/odoo-maestros.models';
import { OdooMaestrosService } from 'src/app/services/odoo/odoo-maestros.service';
import { OdooCarga } from 'src/app/services/odoo/odoo.models';
import { conCarga } from 'src/app/services/odoo/odoo.service';

const fNumero = new Intl.NumberFormat('es-VE');

/** PESTAÑA COMERCIOS. Buscador (nombre/RIF) con espera de 300 ms, filtro Estado y paginación en el servidor. */
@Component({
  selector: 'app-odoo-comercios',
  templateUrl: './odoo-comercios.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OdooComerciosComponent implements OnDestroy {
  readonly limite = 20;
  filtro: OdooListaFiltro = { q: '', estado: '', comercio: '', page: 1, limit: this.limite };
  readonly buscar = new FormControl('');
  readonly estados: { valor: OdooEstadoUi | ''; texto: string }[] = [
    { valor: '', texto: 'Todos' },
    { valor: 'anotado', texto: 'Anotado' },
    { valor: 'esperando', texto: 'Esperando envío' },
    { valor: 'problema', texto: 'Con problema' },
  ];
  readonly esperaSkeleton = [0, 1, 2];
  readonly trackFila = trackPorCodigo;
  readonly porIndice = (i: number): number => i;
  readonly porValor = (_: number, e: { valor: string }): string => e.valor;

  private readonly params$ = new BehaviorSubject<OdooListaFiltro>(this.filtro);
  readonly lista$: Observable<OdooCarga<OdooPaginaLista<OdooFilaComercio>>> = conCarga(this.params$, (f) => this.api.comercios(f));
  private readonly sub: Subscription;

  constructor(private api: OdooMaestrosService) {
    this.sub = this.buscar.valueChanges.pipe(
      map((v) => String(v || '').trim()), debounceTime(300), distinctUntilChanged(),
    ).subscribe((q) => this.cambiar({ q, page: 1 }));
  }

  ngOnDestroy(): void { this.sub.unsubscribe(); }

  private cambiar(parcial: Partial<OdooListaFiltro>): void {
    this.filtro = { ...this.filtro, ...parcial };
    this.params$.next(this.filtro);
  }

  elegirEstado(valor: string): void { this.cambiar({ estado: valor as OdooEstadoUi | '', page: 1 }); }
  pagina(n: number): void { this.cambiar({ page: n }); }
  recargar(): void { this.params$.next({ ...this.filtro }); }

  totalPaginas(total: number): number { return Math.max(1, Math.ceil(total / this.limite)); }
  numero(n: number): string { return fNumero.format(n); }
  desde(p: OdooPaginaLista<unknown>): number { return p.total ? (p.page - 1) * p.limit + 1 : 0; }
  hasta(p: OdooPaginaLista<unknown>): number { return Math.min(p.total, p.page * p.limit); }
}
